import { db } from './firebase';

export const getHallName = async (hallID) => {
  const doc = await db
    .collection('halls').doc(hallID)
    .get();
  const name = doc.get('name');
  return name;
}

export const getHalls = async () => {
  const hallsRef = await db
    .collection('halls')
    .get();
  const halls = hallsRef.docs.map((hall) => {
    return { id: hall.id, ...hall.data() };
  });
  return halls;
}

	